module.exports = __webpack_public_path__ + "img/devices.83cae959.png";